import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { DeleteControlGrade, LoadControlRoles } from '../../_stores/control/_actions/control.actions';
import { ModalState } from '../../_stores/modal/_state/modal.state';
import { ModalCloseAction } from '../../_stores/modal/_actions/modal.actions';

@Component({
  selector: 'ui-control-grade-delete',
  templateUrl: './ui-control-grade-delete.component.html',
  styleUrls: ['./ui-control-grade-delete.component.scss'],
})
export class UiControlGradeDeleteComponent implements OnInit {
  interface: any = {
    _id: null,
  };

  constructor(private store: Store, private cdr: ChangeDetectorRef) {
    this.store.dispatch(new LoadControlRoles());
  }

  ngOnInit(): void {
    this.initDataID();
  }

  initDataID() {
    this.store.select(ModalState.selectOpenedID).subscribe((_openedID) => {
      this.interface._id = _openedID;
      this.cdr.detectChanges();
    });
  }

  actionConfirm(): void {
    this.store.dispatch(new DeleteControlGrade({ gradeID: this.interface._id })).subscribe({
      next: () => {
        this.interface.loading = false;
        this.store.dispatch(new ModalCloseAction());
        this.cdr.detectChanges();
      },
      error: () => {
        this.interface.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  actionClose() {
    this.store.dispatch(new ModalCloseAction());
  }
}
